import React, { useState, useEffect } from "react";
import {
    List as RaList, Datagrid, TextField, TextInput, SelectInput, Button,
    useDataProvider, DateField, TopToolbar, useListContext,
    DateInput,
    useNotify,
    FunctionField,
} from "react-admin";
import { SnManagementCreate } from "./SnManagementCreate";
import { SnVerify } from "./SnVerify";

const typeStatus = [
    { id: 0, name: '未校验' },
    { id: 1, name: '已校验' },
    { id: 2, name: '校验失败' }
];

const ListActions = () => {
    const { setFilters, filterValues } = useListContext();
    const dataProvider = useDataProvider();
    const [bindSnOpen, setBindSnOpen] = useState(false);
    const [verifySnOpen, setVerifySnOpen] = useState(false);

    const notify = useNotify(); // 获取通知方法

    const initialFilters = {};  // 初始过滤器值
    const handleResetFilters = () => {
        setFilters(initialFilters);
    };

    const exportDetails = () => {
        if (window.confirm(`确认导出内容？`)) {
            const formData = {
                ...filterValues,
            };
            dataProvider.exportTrifficSnList(formData)
                .then(() => {
                    notify('确认导出成功', { type: 'success' });
                })
                .catch((error: any) => {
                    notify(error.message || '确认导出失败', { type: 'error' });
                })
        }
    }

    return (
        <TopToolbar>
            <Button
                label="重置搜索"
                onClick={handleResetFilters}
                disabled={Object.keys(filterValues).length === 0}
            />
            <Button
                label="生成流量SN"
                onClick={() => { setBindSnOpen(true) }}
            />
            <Button
                label="流量SN校验"
                onClick={() => { setVerifySnOpen(true) }}
            />
            <Button
                label="导出"
                onClick={exportDetails}
            />
            <SnManagementCreate
                open={bindSnOpen}
                onClose={() => setBindSnOpen(false)}
            />
            <SnVerify
                open={verifySnOpen}
                onClose={() => setVerifySnOpen(false)}
            />
        </TopToolbar>
    );
};

export const xunleiSnManageList = () => {
    const dataProvider = useDataProvider();
    const [customerTypeChoices, setSaleCustomers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                setLoading(true);
                const salesData = await dataProvider.getSalesCustomers()
                setSaleCustomers(salesData.map(item => ({ id: item.id, name: item.name })));
            } catch (error) {
                console.error("获取客户数据失败:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCustomers();
    }, []);

    const postFilters = [
        <SelectInput
            source="saleCustomerId"
            label="设备商家"
            choices={customerTypeChoices}
            disabled={loading}
            alwaysOn
        />, 
        < TextInput
            source = "sn"
            label = "设备SN"
            alwaysOn
        />,
        <TextInput
            source="trafficSn"
            label="流量SN"
            alwaysOn
        />,
        <DateInput
            label="开始日期"
            alwaysOn
            source="startDate"
            defaultValue={undefined}  // 明确设置为 undefined
        />,
        <DateInput
            label="结束日期"
            alwaysOn
            source="endDate"
            defaultValue={undefined}  // 明确设置为 undefined
        />,
        <TextInput
            source="batchNo"
            label="流量SN批次号"
            alwaysOn
        />,
        <SelectInput
            source="verifyStatus"
            label="校验状态"
            choices={typeStatus}
            disabled={loading}
            alwaysOn
        />
    ];

    const permanentFilter = {};

    return (
        <>
            <RaList
                filter={permanentFilter}
                filters={postFilters}
                actions={<ListActions />}
                empty={false}
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source="id" label="序号" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <TextField source="sn" label="设备SN" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <TextField source="trafficSn" label="流量SN" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <TextField source="batchNo" label="流量SN批次号" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <TextField source="trafficCustomerName" label="流量商家" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <TextField source="saleCustomerName" label="设备商家" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <FunctionField
                        label="校验状态"
                        source="verifyStatus"
                        render={record => {
                            let str = '未校验'
                            switch (record.verifyStatus) {
                                case 1:
                                    str = '已校验'
                                    break;
                                case 2:
                                    str = '校验失败'
                                    break;
                            }
                            return str
                        }
                        }
                        sortable={false}
                        sx={{
                            whiteSpace: 'nowrap',
                        }}
                    />
                    <DateField source="createTime" label="流量SN生成日期" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                </Datagrid>
            </RaList>
        </>
    )
}